import React, { useState } from 'react'
import { ScrollView, View } from 'react-native'

import { useNavigation } from '@react-navigation/native'
import { FlashList } from '@shopify/flash-list'
import { Icon } from '@zet/design-system'
import { Stack } from '@zet/design-system/layout'
import Pressable from '@zet/design-system/pressable'
import { H4 } from '@zet/design-system/typography'

import API from '../../api/endpoints'
import { useApiAction } from '../../api/useApiAction'
import Footer from '../footer/footer'
import SectionCard from './sectionCard'

const Review = (_props) => {
  const { props, userDetails } = _props

  const leadSource = userDetails?.leadSource || null

  const { mutate, data, hash, isLoading, state } = useApiAction()
  const consents = props?.consents
  const prevState = data?.prevState || ''
  const [userConsents, setUserConsents] = useState(
    Array(consents?.length).fill(true)
  )

  const navigation = useNavigation()

  const goToPrevState = () => {
    navigation.replace('BrandsCC', {
      state: prevState,
      hash,
    })
  }

  const onSubmit = () => {
    const headers = {
      hash: encodeURIComponent(hash),
    }

    const body = {
      method: 'POST',
      state,
    }

    const endpointConfig = API.stateManage

    mutate({
      ...endpointConfig,
      body,
      headers,
      state,
    })
  }

  const showUserConsent = (() => {
    if (data?.state === 'PL_REVIEW' || data?.state === 'HL_REVIEW') {
      if (leadSource === 'plApp') {
        return [consents[0]]
      } else {
        return [consents[1]]
      }
    } else {
      return consents
    }
  })()

  return (
    <>
      <Stack className="p-3">
        {prevState ? (
          <Stack className="mb-3 items-start">
            <Pressable
              className="rounded bg-[#F5F7FB] p-1"
              onPress={goToPrevState}
            >
              <Icon type="ArrowLeft" color="#2F3440" />
            </Pressable>
          </Stack>
        ) : null}

        <H4>Review Application</H4>
      </Stack>
      <ScrollView className="flex-1">
        <FlashList
          data={data?.layout?.sections || data?.layout?.section}
          renderItem={({ item }) => (
            <SectionCard
              fields={item?.fields}
              state={item?.state}
              title={item?.title}
              disabled={isLoading}
            />
          )}
          ItemSeparatorComponent={() => <View className="bg-white py-2" />}
        />
      </ScrollView>
      <Footer
        buttonProps={{
          loading: isLoading,
          onPress: onSubmit,
          disabled: !userConsents.every((element) => element === true),
        }}
        disabled={true}
        consents={showUserConsent}
        userConsents={userConsents}
        setUserConsents={setUserConsents}
      />
    </>
  )
}

export default Review
